import { render } from "./BlViewVoice.vue?vue&type=template&id=b9c5951a&scoped=true"
import script from "./BlViewVoice.vue?vue&type=script&lang=js"
export * from "./BlViewVoice.vue?vue&type=script&lang=js"

import "./BlViewVoice.vue?vue&type=style&index=0&id=b9c5951a&scoped=true&lang=scss"

import exportComponent from "/tmp/4f365a42-b3f2-4061-98cc-f7413900e2b1/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c5951a"]])

export default __exports__